module.exports = __webpack_public_path__ + "img/default_chatavatar.43e245e5.png";